<template lang="html">
  <div>
    <v-dialog v-model="show" width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{titulo}}</v-card-title>
        <v-card-text class="title" align="justify" style="word-break: break-word; margin-top: 10px;"><slot></slot></v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="clicouNao()">Não</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="clicouSim()">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props: ['value', 'titulo'],
    data: () => ({
      show: false
    }),
    watch: {
      value: function (val) {
        this.show = val
      }
    },
    methods: {
      setShow (val) {
        this.$emit('input', val)
      },
      clicouSim () {
        this.setShow(false)
        this.$emit('yes')
      },
      clicouNao () {
        this.setShow(false)
        this.$emit('no')
      }

    }
  }
</script>



// WEBPACK FOOTER //
// c-confirm-dialog.vue?371dd061